import React from 'react';
import { css } from '@emotion/css';
import bgimage from '../img/header.jpg';
import logo2 from '../img/logo2.svg';

function Header() {
  return (
    <div className={style.container}>
      <img src={logo2} alt="" className={style.logo} />
    </div>
  );
}

const style = {
  container: css`
    background-image: url(${bgimage});
    background-size: cover;
    background-position: 50% 40%;
    height: 50vh;
    min-height: 25vw;
    display: flex;
    justify-content: space-around;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
  `,
  logo: css`
    opacity: 0.35;
    margin: auto;
    width: calc(100% - 100px);
    max-height: calc(100% - 100px);
    @media (max-width: 640px) {
      width: calc(100% - 40px);
      max-height: calc(100% - 40px);
    }
  `,
};

export default Header;
